export const ACTION_NAMES = {
  base: 'pendingActions:base',
  businessProfile: 'pendingActions:businessProfile',
  overview: 'pendingActions:overview',
} as const;
